import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Servizi from "./pages/Servizi";
import ServicePage from "./pages/ServicePage";
import ComeFunziona from "./pages/ComeFunziona";
import RichiediValutazione from "./pages/RichiediValutazione";
import { PrivacyPolicy, CookiePolicy, Informazioni } from "./pages/Legal";
import NotFound from "./pages/NotFound";

const SERVICE_ROUTES = [
  "servizi-catastali",
  "conformita-urbanistica-catastale",
  "visure-verifiche-immobiliari",
  "successioni",
  "ape-perizie-valutazioni",
  "urbanistica-edilizia",
  "sicurezza-prevenzione",
  "consulenza-tecnica-documentale",
  "siti-web-personalizzati",
];

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="grid min-h-screen place-items-center bg-paper px-5 text-center">
          <div>
            <p className="eyebrow">DN Studio Tecnico</p>
            <h1 className="mt-4 font-display text-2xl font-bold text-antracite">Si è verificato un errore imprevisto</h1>
            <button
              type="button"
              onClick={() => window.location.reload()}
              data-testid="error-reload-button"
              className="btn-primary mt-6"
            >
              Ricarica la pagina
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <div className="flex min-h-screen flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/servizi" element={<Servizi />} />
              {SERVICE_ROUTES.map((r) => (
                <Route key={r} path={`/${r}`} element={<ServicePage slug={r} />} />
              ))}
              <Route path="/come-funziona" element={<ComeFunziona />} />
              <Route path="/richiedi-valutazione" element={<RichiediValutazione />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/informazioni" element={<Informazioni />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
